module.exports = __webpack_public_path__ + "static/media/thumbnail_awards_2021.1770b6ef.png";